import { FlowDefinitionRepository } from '@domain/flow-definition/repositories/flow-definition.repository';
import { FlowDefinitionRepositoryService } from '../repositories/flow-definition.service';

export const FlowDefinitionProvider = [
  {
    provide: FlowDefinitionRepository,
    useClass: FlowDefinitionRepositoryService,
  },
];
